module.exports = __webpack_public_path__ + "images/places/training_690-589b698307394b5aaa15c6011ee6fa84.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_690.jpg
 ** module id = 324
 ** module chunks = 0
 **/